export default __webpack_public_path__ + "static/media/bonifacio_city.d357509d.jpg";